module.exports = __webpack_public_path__ + "img/la_bellenergie_120X35.4317d123.png";